<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ "ONT Upgrade" }}</div>
        <!--按钮-->
        <div v-if="activeIndex == 1" class="pageButton">
          <button
            type="button"
            class="btn btn-primary"
            style="
              min-width: 77px;
              color: #fff;
              background-color: #008b8b;
              border-color: #008080;
              margin-right: 10px;
            "
            @click="ontUpgradeSet()"
          >
            {{ "Upgrade" }}
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the upgrade configuration of ont List." }}
      </p>
    </div>
    <tabs v-model="activeIndex">
      <pane label="Load Ont-Image">
        <upgrade-fw></upgrade-fw>
      </pane>
      <pane label="ONT Upgrade">
        <div class="row">
          <div class="col-lg-12">
            <!-- ONT列表 -->
            <block-cntr :btitle="'ONT Upgrade'" style="height: 380px">
              <!-- 按钮 -->
              <div class="form-inline" style="height: 35px">
                <span style="float: left">
                  <div class="btn-group open">
                    <div
                      @click="loadOntUpgradelist()"
                      class="btn"
                      :class="{}"
                      style="padding: 0px"
                    >
                      <i class="fa fa-refresh page-tableaction"></i>
                    </div>
                  </div>
                </span>
                <span style="margin-left: 25px; font-weight: bold"
                  >Total entries: {{ total }}</span
                >
              </div>
              <!-- ONT upgrade table-->
              <table
                class="table table-hover table-noneborder-top"
                style="overflow-x: auto"
              >
                <thead>
                  <tr>
                    <th width="40px">
                      <input
                        type="checkbox"
                        v-model="isSelectAll"
                        @change="changeSelectAll()"
                        id="idSelectAllOnt"
                      />
                      <label for="idSelectAllOnt"></label>
                    </th>
                    <th>
                      <div>
                        {{ ontUpgradeList.title.ontid }}
                        <label style="position: relative; margin-left: 0px">
                          <i
                            style="position: absolute; top: 3px; left: 5px"
                            class="fa fa-filter"
                          ></i>
                          <input
                            type="text"
                            v-model="searchInfo.ont"
                            class="form-control"
                            maxlength="8"
                            style="width: 90%; height: 20px; padding-left: 20px"
                          />
                        </label>
                      </div>
                    </th>
                    <th>
                      <div>
                        {{ ontUpgradeList.title.sn }}
                        <label style="position: relative; margin-left: 0px">
                          <i
                            style="position: absolute; top: 3px; left: 5px"
                            class="fa fa-filter"
                          ></i>
                          <input
                            type="text"
                            v-model="searchInfo.sn"
                            class="form-control"
                            maxlength="16"
                            style="width: 90%; height: 20px; padding-left: 20px"
                          />
                        </label>
                      </div>
                    </th>

                    <th>
                      <div>
                        {{ ontUpgradeList.title.devtype }}
                        <label style="position: relative; margin-left: 0px">
                          <i
                            style="position: absolute; top: 3px; left: 5px"
                            class="fa fa-filter"
                          ></i>
                          <input
                            type="text"
                            v-model="searchInfo.devType"
                            class="form-control"
                            style="width: 90%; height: 20px; padding-left: 20px"
                          />
                        </label>
                      </div>
                    </th>
                    <th>
                      <div>
                        {{ ontUpgradeList.title.sw }}
                        <label style="position: relative; margin-left: 0px">
                          <i
                            style="position: absolute; top: 3px; left: 5px"
                            class="fa fa-filter"
                          ></i>
                          <input
                            type="text"
                            v-model="searchInfo.sw"
                            class="form-control"
                            maxlength="14"
                            style="width: 90%; height: 20px; padding-left: 20px"
                          />
                        </label>
                      </div>
                    </th>
                    <th>{{ ontUpgradeList.title.status }}</th>
                  </tr>
                </thead>
                <tbody style="height: 350px">
                  <tr v-for="(row, index) in ontUpgradeFilter" :key="row.ontid">
                    <td width="40px">
                      <div>
                        <input
                          type="checkbox"
                          v-model="row.selected"
                          :id="'idRowSelectOnt' + index"
                        />
                        <label :for="'idRowSelectOnt' + index"></label>
                      </div>
                    </td>
                    <td>
                      {{ row.ontid }}
                    </td>
                    <td>
                      {{ row.sn }}
                    </td>
                    <td>
                      {{ row.devtype }}
                    </td>
                    <td>
                      {{ row.sw }}
                    </td>
                    <td>
                      <div
                        class="fa fa-circle"
                        :style="{
                          color:
                            row.status === 'online' ? '#32CD32' : '#FF4500',
                        }"
                      ></div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!--ont upgrade set-->
              <div v-if="ontUpgradeEdit == true">
                <dialog-box
                  :btitle="'Upgrade Set'"
                  style="min-height: 100%"
                  @close="ontUpgradeEdit = false"
                  :closeButton="true"
                >
                  <form class="form-horizontal" role="form">
                    <div class="form-group">
                      <label class="col-sm-3 control-label" for="ipmode"
                        >Mode</label
                      >
                      <div class="col-sm-5">
                        <select
                          type="text"
                          class="form-control"
                          id="ipmode"
                          v-model="ontUpgradeMode"
                        >
                          <option
                            label="auto reboot"
                            value="autoReboot"
                          ></option>
                          <option
                            label="manual reboot"
                            value="manualReboot"
                          ></option>
                        </select>
                      </div>
                    </div>

                    <button
                      type="button"
                      class="btn btn-primary"
                      style="
                        margin-left: 20%;
                        min-width: 77px;
                        color: #fff;
                        background-color: #008b8b;
                        border-color: #008080;
                      "
                      @click="clkApply()"
                    >
                      {{ "Apply" }}
                    </button>
                    <span style="margin-left: 10px">
                      <button
                        type="button"
                        class="btn btn-default"
                        style="min-width: 77px"
                        @click="clkCancel()"
                      >
                        {{ "Cancel" }}
                      </button>
                    </span>
                  </form>
                </dialog-box>
              </div>
            </block-cntr>
          </div>
        </div>
      </pane>
      <pane label="Upgrade Status">
        <upgrade-status></upgrade-status>
      </pane>
    </tabs>
    <info-box :ibox="iBox"></info-box>
  </div>
</template>

<script>
import en from "../lang/en-US.js"
import BlockCntr from "../components/BlockCntr.vue"
import DialogBox from "@/components/DialogBox"
import InfoBox from "@/components/InfoBox.vue"
import { get, post } from "@/utils/http.js"
import tabs from "@/components/Tabs.vue"
import pane from "@/components/Pane.vue"
import UpgradeStatus from "@/views/OntUpgradeStatus.vue"
import UpgradeFw from "@/views/OntUpgradeFw.vue"


export default {
  name: "ontUpgrade",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
    tabs,
    pane,
    UpgradeStatus,
    UpgradeFw,
  },
  data() {
    return {
      iBox: {},
      activeIndex: 0,
      ontUpgradeList: "",
      total: "",
      ontUpgradeMode: "",
      ontUpgradeEdit: false,
      isSelectAll: false,
      searchInfo: {
        ont: "",
        sn: "",
        devType: "",
        sw: "",
      },
    }
  },
  created() {
    this.loadOntUpgradelist()
  },
  methods: {
    loadOntUpgradelist() {
      get("ontUpgradeList")
        .then((res) => {
          this.ontUpgradeList = res.data
        })
        .catch((err) => {
          this.ontUpgradeList = en.ontUpgradeList
        })
    },
    ontUpgradeSet() {
      for (let i = 0; i < this.ontUpgradeList.data.length; i++) {
        if (this.ontUpgradeList.data[i].selected) {
          this.ontUpgradeEdit = true
          this.ontUpgradeMode = "autoReboot"
          return
        }
      }
    },
    clkApply() {
      var upgradeConfig = {
        upgradeMode:this.ontUpgradeMode,
        ontList: [],
      }

      for (let i = 0; i < this.ontUpgradeList.data.length; i++) {
        if (this.ontUpgradeList.data[i].selected == true) {
          upgradeConfig.ontList.push({ ont: this.ontUpgradeList.data[i].ontid })
        }
      }
      if (upgradeConfig.ontList.length == 0) {
        return
      }

      post("ontUpgrade", upgradeConfig)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          )
            this.showAlertBox("info", "Info", res.data.msg)
          else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
      this.ontUpgradeEdit = false
      this.selectNull()
      return
    },
    clkCancel() {
      this.ontUpgradeEdit = false
    },

    changeSelectAll() {
      for (let i = 0; i < this.ontUpgradeFilter.length; i++) {
        if (this.isSelectAll) {
          this.ontUpgradeFilter[i].selected = true
        } else {
          this.ontUpgradeFilter[i].selected = false
        }
      }
    },

    selectNull() {
      for (let i = 0; i < this.ontUpgradeList.data.length; i++) {
        this.ontUpgradeList.data[i].selected = false
      }
      this.isSelectAll = false
    },
    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
  computed: {
    ontUpgradeFilter() {
      var ontTable = []
      var number = 0
      if (this.ontUpgradeList.data !== undefined)
        this.ontUpgradeList.data.forEach((element) => {
          if (
            (this.searchInfo.ont == "" ||
              (element["ontid"].split("/")[0] ==
                this.searchInfo.ont.split("/")[0] &&
                element["ontid"].split("/")[1] ==
                  this.searchInfo.ont.split("/")[1] &&
                (element["ontid"].split("/")[2] ==
                  this.searchInfo.ont.split("/")[2] ||
                  this.searchInfo.ont.split("/")[2] == undefined))) &&
            (this.searchInfo.sn == "" ||
              element["sn"].indexOf(this.searchInfo.sn) !== -1) &&
            (this.searchInfo.devType == "" ||
              element["devtype"] == this.searchInfo.devType) &&
            (this.searchInfo.sw == "" || element["sw"] == this.searchInfo.sw)
          ) {
            ontTable.push(element)
            number += 1
          }
        })
      this.total = number
      return ontTable
    },
  },
}
</script>